import produce from "immer";
import margeById from "../../helpers/margeById";

export const actions = {
  /**
   * Action that fire/trigger redux-saga watchers
   */
  CREATE_ARTISAN_CATEGORY: "CREATE_ARTISAN_CATEGORY",
  GET_ARTISAN_CATEGORIES: "GET_ARTISAN_CATEGORIES",
  UPDATE_ARTISAN_CATEGORY: "UPDATE_ARTISAN_CATEGORY",
  /**
   * Actions that are fired BY redux-saga watchers after a response
   */

  GET_ARTISAN_PARENT_CATEGORIES: 'GET_ARTISAN_PARENT_CATEGORIES',

  GET_ARTISAN_PARENT_CATEGORIES_SUCCESS: 'GET_ARTISAN_PARENT_CATEGORIES_SUCCESS',
   
  GET_ARTISAN_CATEGORIES_SUCCESS: "GET_ARTISAN_CATEGORIES_SUCCESS",
  CREATE_ARTISAN_CATEGORY_SUCCESS: "CREATE_ARTISAN_CATEGORY_SUCCESS",
  UPDATE_ARTISAN_CATEGORY_SUCCESS: "UPDATE_ARTISAN_CATEGORY_SUCCESS",
  /**
   * Misc
   */
  SET_ARTISAN_CATEGORIES_IS_LOADING: "SET_ARTISAN_CATEGORIES_IS_LOADING",
  SET_ARTISAN_CATEGORIES_COUNT: "SET_ARTISAN_CATEGORIES_COUNT",
  SET_AC_SEARCH_VALUE  : "SET_AC_SEARCH_VALUE"
};

const initialState = {
  items: [],
  parent: [],
  isLoading: false,
  count: 0,
  searchValue : ""
};

export default produce((draft, action) => {
  const { type, payload } = action;

  if (!draft) {
    return initialState;
  }

  switch (type) {
    case actions.CREATE_ARTISAN_CATEGORY_SUCCESS: {
      const currentCategories = draft.items;
      const category = payload;
      draft.items = margeById(currentCategories, [category]);
      break;
    }

    case actions.GET_ARTISAN_PARENT_CATEGORIES_SUCCESS: {
       const currentCategories = draft.parent;
      const category = payload;
      draft.parent = margeById(currentCategories, category);
      break;
    }

    case actions.GET_ARTISAN_CATEGORIES_SUCCESS: {
      const currentCategories = draft.items;

      draft.items = margeById(currentCategories, payload);

      /*       draft.items = payload;
       */ break;
    }

    case actions.UPDATE_ARTISAN_CATEGORY_SUCCESS: {
      const updatedCategory = payload;
      const targetIndex = draft.items.findIndex(
        (category) => category._id === updatedCategory._id
      );
      draft.items[targetIndex] = updatedCategory;
      break;
    }

    /**
     * Misc
     */

    case actions.SET_ARTISAN_CATEGORIES_IS_LOADING: {
      draft.isLoading = payload;
      break;
    }

    case actions.SET_ARTISAN_CATEGORIES_COUNT: {
      draft.count = payload;
      break;
    }

    case actions.SET_AC_SEARCH_VALUE : {
      draft.items = [];
      draft.searchValue = payload
      break;
    }

    default:
      break;
  }
});
